module.exports = __webpack_public_path__ + "static/placeholder-71fead809ad76cb81c3029ce3367da28.png";